import Vue from 'vue'
import '@/registerServiceWorker'
import store from '@/store'

import { AppSettings } from "@/types";
import * as authModule from "./AuthModule";

import { FetchManager } from "./FetchManager";
import { GRAPH_CONFIG } from "./Constants";
import * as types from '@/types'

export class AuthWrapper {
    private _authModule: authModule.AuthModule;
    private _networkModule: FetchManager = new FetchManager();
    private _appConfig: AppSettings;
    /**
     *
     */
    constructor() {
    }

    public login(): void {
        this._authModule.login(authModule.LogInType.LOGIN_REDIRECT);
    }

    /**
     * Called when user clicks "Sign Out"
     */
    public logout(): void {
        this._authModule.logout();
    }

    public get account(): authModule.AccountInfo {
        return this._authModule.account;
    }

    public handleRedirect() {
        this._authModule.loadAuthModule();
    }

    public init(appConfig: AppSettings) {
        this.initAuth(appConfig);
        // Vue.prototype.$auth = this;
        store.watch(() => store.getters.account, this.onAccountChanged.bind(this));
    }

    private async onAccountChanged(newValue, oldValue) {
        if (!newValue.username) return;

        this.seeProfile().then((profile) => {
            store.commit("SET_PROFILE", profile);
        });
    }

    private initAuth(appConfig: AppSettings) {
        let config: authModule.Configuration = authModule.authConfiguration;
        config.auth.redirectUri = appConfig.url;
        config.auth.postLogoutRedirectUri = appConfig.url;
        this._appConfig = appConfig;

        this._authModule = new authModule.AuthModule(config, appConfig.scopes);
    }

    public async seeProfile(): Promise<authModule.UserInfo> {
        const token = await this._authModule.getProfileTokenRedirect();
        if (token && token.length > 0) {
            const graphResponse = await this._networkModule.callEndpointWithToken(GRAPH_CONFIG.GRAPH_ME_ENDPT, token);
            return <authModule.UserInfo>graphResponse;
        }
    }

    public async getSoftware(): Promise<types.SoftwareItem[]> {
        const token = await this._authModule.getDownloadTokenRedirect();
        if (token && token.length > 0) {
            const graphResponse = await this._networkModule.callEndpointWithToken(`${this._appConfig.softwareApiUrl}/api/software/available`, token);
            return <types.SoftwareItem[]>graphResponse;
        }
    }

    public async getSoftwareDownloadUrl(softwareId: string, version?: string | undefined): Promise<string> {
        const baseUrl = `${this._appConfig.softwareApiUrl}/api/software/zip/${softwareId}/${version || ""}`;

        const token: string = await this.getDownloadToken();
        if (token && token.length > 0) {
            return baseUrl + `?access_token=${token}`;
        }
    }

    public async getDownloadToken(): Promise<string> {
        return await this._authModule.getDownloadTokenRedirect();
    }

}

Object.defineProperty(Vue.prototype, "auth", () => { });